import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid2 as Grid,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { specialistMenus } from "../../../components/dashboard/Sidebar/data";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../components/dashboard/Sidebar";
import Icons from "../../../assets/js/Icons";
import { Fragment, Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { FILE_PATH_URI } from "../../../utils/helper";
import TopBannerA from "../../../components/common/TopBannerA";
import Images from "../../../assets/js/Images";

function Dashboard() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [anchor, setAnchor] = useState(null);
  const { specialist } = useSelector((state) => state.authSlice);
  const { appointmentUnreadCount, messagesUnreadCount } = useSelector((state) => state.socketSlice);

  const open = Boolean(anchor);
  const handleCloseMenu = () => {
    setAnchor(null);
  };

  const handleClickMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  return (
    <Fragment>
      <Box component="section" padding={2} bgcolor="#ececec">
        <Box bgcolor="white" borderRadius="8px">
          <Box sx={{ position: "relative" }}>
            <Suspense fallback={<Skeleton />}>
              <TopBannerA
                bannerImg={Images?.dashboard}
                heading="Specialist"
                currentPage={"specialist / profile"}
              />
            </Suspense>

            <Box
              sx={{
                p: 0.5,
                bottom: 0,
                border: "2px solid",
                position: "absolute",
                left: { xs: "50%", sm: "20px" },
                transform: {
                  xs: "translate(-50%, 50%)",
                  sm: "translateY(50%)",
                },
                borderRadius: "100px",
                borderColor: "other.color1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{
                  width: { xs: 100, md: 150, xl: 180 },
                  height: { xs: 100, md: 150, xl: 180 },
                }}
                src={
                  specialist?.profile?.profilePhoto
                    ? `${FILE_PATH_URI}${specialist.profile.profilePhoto}`
                    : specialist?.specialist?.image !==
                      `${FILE_PATH_URI}undefined`
                      ? specialist?.specialist?.image
                      : ""
                }
              />
            </Box>
          </Box>
          <Box
            sx={{
              py: 2,
              pr: "20px",
              minHeight: { xs: "66px", md: "91px", xl: "106px" },
              pl: { xs: "20px", md: "200px", xl: "230px" },
              pt: { xs: "4rem" },
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid size={{ xs: 12, md: "grow" }}>
                <Typography
                  fontSize={36}
                  component="h6"
                  lineHeight="1.2"
                  fontWeight="600"
                  color="other.color1"
                  textTransform="capitalize"
                >
                  {specialist?.specialist?.fullName}
                </Typography>
                <Stack spacing={0.5} direction="row">
                  {new Array(5).fill().map((_, i) => (
                    <Icon
                      key={i}
                      sx={{
                        fontSize: 18,
                        color: i < 4 ? "secondary.main" : "#d6d6d6",
                      }}
                    >
                      <Icons.Star />
                    </Icon>
                  ))}{" "}
                  (12)
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, md: "auto" }}>
                <Box
                  sx={{
                    gap: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    LinkComponent={Link}
                    to="/specialist/edit-profile"
                  >
                    Edit Profile
                  </Button>
                  <IconButton
                    onClick={handleClickMenu}
                    sx={{ display: { xs: "flex", lg: "none" } }}
                  >
                    <Icons.Menu />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          p: 2,
          bgcolor: "#ececec",
        }}
        component="section"
      >
        <Grid className="tesdslksldj" container spacing={3}>
          <Grid size="auto" sx={{ display: { xs: "none", lg: "block" } }}>
            <Sidebar menus={specialistMenus} />
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }}>
            <Box
              sx={{
                p: 3,
                height: "100%",
                bgcolor: "white",
                borderRadius: "8px",
              }}
            >
              <Outlet />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Menu
        sx={{
          ".MuiPaper-root": {
            borderRadius: "8px",
            boxShadow: "0px 0px 10px 0px #0000000a",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        anchorEl={anchor}
        onClose={handleCloseMenu}
      >
        {specialistMenus?.map((menu, i) => {
          const isAppointmentChat = menu?.name?.toLowerCase() === "appointment chat" || menu?.path?.includes("appointment-messages");
          const isGeneralMessages = menu?.name?.toLowerCase() === "messages" || (menu?.path?.includes("/messages") && !menu?.path?.includes("appointment-messages"));
          return (
            <MenuItem
              key={i}
              sx={{
                textTransform: "capitalize",
                bgcolor: menu?.path === pathname ? "#2f425017" : "transparent",
                ":hover": { bgcolor: "#2f425017" },
              }}
            >
              <Button
                sx={{
                  p: 0,
                  lineHeight: 1,
                  fontSize: "15px",
                  fontWeight: "400",
                  minHeight: "auto",
                  flexDirection: "row",
                  alignItems: "center",
                  color: "other.color2",
                  fontFamily: "Poppins",
                  justifyContent: "start",
                  width: "100%",
                  textTransform: "capitalize",
                }}
                key={i}
                onClick={() => {
                  navigate(
                    menu?.path,
                    { state: (menu?.path === "/specialist/profile/messages" || menu?.path === "/specialist/profile/appointment-messages") ? "test" : null }
                  )
                  handleCloseMenu()
                }}
                startIcon={menu?.icon}
              >
                {menu?.name}
                {isAppointmentChat && appointmentUnreadCount > 0 && (
                  <Chip
                    label={appointmentUnreadCount > 99 ? "99+" : appointmentUnreadCount}
                    size="small"
                    color="error"
                    sx={{
                      height: 20,
                      fontSize: "11px",
                      fontWeight: 600,
                      fontFamily: "Poppins",
                      ml: "auto",
                    }}
                  />
                )}
                {isGeneralMessages && messagesUnreadCount > 0 && (
                  <Chip
                    label={messagesUnreadCount > 99 ? "99+" : messagesUnreadCount}
                    size="small"
                    color="error"
                    sx={{
                      height: 20,
                      fontSize: "11px",
                      fontWeight: 600,
                      fontFamily: "Poppins",
                      ml: "auto",
                    }}
                  />
                )}
              </Button>
            </MenuItem>
          );
        })}
      </Menu>
    </Fragment>
  );
}

export default Dashboard;
